import React, { useEffect, useState } from "react";
import TitleComp from "../components/Title/title";
import { useDrawer } from "../context/drawer";
import axios from "axios";
import DrawerComp from "../components/Drower/Drawer";
import { useSelector } from "react-redux";
import FetchCardList from "../components/CardList/FoodCardList";
import { Spin } from "antd";

export default function FoodItems() {
  const [fetchList, setFetchList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageComp, setPageComp] = useState(1);
  const [limitComp, setLimitComp] = useState(21);
  const [totalData, setTotalData] = useState(null);
  const [branch, setBranch] = useState("");
  const [category, setCategory] = useState("default");
  const [search, setSearch] = useState("");

  // =========================================== Drawer Context =========================

  const { drawerData, setDrawerData } = useDrawer();

  const { token } = useSelector((state) => state.auth);

  const fetchData = async (page, limit, search, branch, category) => {
    try {
      const formData = new FormData();
      formData.append("token", token);
      setLoading(true);
      const response = await axios.post(
        "https://indiandelightms.com/api/food-details.php?action=fetch&page=" +
          page +
          "&limit=" +
          limit +
          "&search=" +
          search +
          "&branch=" +
          branch +
          "&category=" +
          category +
          "",
        formData
      );
      if (response.data) {
        setLoading(false);
        setTotalData(response.data.total);
        setFetchList(response.data.list);
      }
    } catch (error) {
      setLoading(false);
      // Handle errors
      console.error("Error making POST request", error);
    }
  };

  useEffect(() => {
    fetchData(
      pageComp,
      limitComp,
      search,
      branch === "default" ? "" : branch,
      category === "default" ? "" : category
    );
    // eslint-disable-next-line
  }, [pageComp, limitComp, branch, category]);

  // ======================= Handle Drawer Add =================================

  const handleDrawerAdd = () => {
    setDrawerData({
      ...drawerData,
      isOpen: true,
      type: "packageAdd",
      title: "Foods Add",
      ID: null,
    });
  };

  return (
    <div>
      <TitleComp
        name="Foods List"
        handleDrawerAdd={handleDrawerAdd}
        totalData={totalData}
        type="Foods"
      />
      <Spin spinning={loading}>
        <FetchCardList
          limitComp={limitComp}
          pageComp={pageComp}
          setPageComp={setPageComp}
          totalData={totalData}
          setLimitComp={setLimitComp}
          loading={loading}
          fetchData={fetchData}
          fetchList={fetchList}
          setCategory={setCategory}
          setBranch={setBranch}
          setSearch={setSearch}
          search={search}
          category={category}
          branch={branch}
          
        />
      </Spin>
      <DrawerComp />
    </div>
  );
}
